
<template>
    <modal @close="toggleViewSelection" style="max-width:550px;height:auto" class="view-selection-modal">
        <template #header>
            <h3 class="td-h4">Select Listing View</h3>
        </template>
        <div class="template-selector">
            <p class="ma-0">Preview listing as: </p>
            <select class="type-select td-select" v-model="listingViewModel.listingTemplateType" aria-label="Listing Template" @change="selectTemplate">
                <option :value="activeTemplate">{{ListingTemplate[activeTemplate]}} (active)</option>
                <option v-if="activeTemplate != ListingTemplate.Pro" :value="ListingTemplate.Pro">Pro</option>
                <option v-if="activeTemplate != ListingTemplate.Branded" :value="ListingTemplate.Branded">Branded</option>
                <option v-if="activeTemplate != ListingTemplate.Elite" :value="ListingTemplate.Elite">Elite</option>
            </select>
            <p class="td-text-mice td-text-subdued mt-1">
                Subscription type determines listing visibility and marketing options.
            </p>
        </div>
        <div class="site-selector">
            <p class="ma-0">Site: </p>
            <select class="type-select td-select" aria-label="Listing Site" v-model="listingViewModel.selectedSite" @change="selectSite">
                <option value="truckdown">TruckDown</option>
                <option value="planrv">PlanRV</option>
            </select>
            <p class="td-text-mice td-text-subdued mt-1" v-if="!hasPlanrvSub">
                This listing is not subscribed to PlanRV. Switching to PlanRV shows a preview only. Content will not appear live on
                <a href="https://www.planrv.com/" class="td-link" target="_blank" title="Planrv Website">PlanRV</a>.
            </p>
            <p class="td-text-mice td-text-subdued mt-1" v-if="hasPlanrvSub">
                This listing has a PlanRV subscription. Switch to PlanRV to view and edit how your listing appears on
                <a href="https://www.planrv.com/" class="td-link" target="_blank" title="Planrv Website">PlanRV</a>.
            </p>

            <label class="td-checkbox-label td-text-bold slim mb-2" for="override-default" v-if="editable">
                <template v-if="showAppplyAllCheckbox">
                    Apply marketing info edits to both sites
                </template>
                <template v-else>
                    Apply marketing info edits only to {{siteName}}
                </template>
                <input name="override-default" id="override-default" type="checkbox" v-model="listingViewModel.overrideDefault"/>
                <span></span>
            </label>
            <div v-if="editable">
                <p class="td-text-mice td-text-subdued mt-1 mb-4" v-if="showAppplyAllCheckbox">
                    When checked, any changes you make to your marketing info (like tagline, description, images)
                    will be applied to both PlanRV and TruckDown listings, keeping them identical.
                    Uncheck this if you want to update each site separately.
                </p>
                <p class="td-text-mice td-text-subdued mt-1 mb-4" v-else>
                    When checked, you can edit marketing info (like tagline, description, images) for {{ siteName }} independently.
                    Uncheck this box if you want both PlanRV and TruckDown listings to have the same marketing details.
                </p>
            </div>
            
        </div>
        <template #footer>
            <div class="actions">
                <button class="td-btn secondary-outlined" title="Cancel View Selection" @click="cancelViewSelection">Cancel</button>
                <button class="primary td-btn" title="View Listing" @click="submitViewSelection">View Listing</button>
            </div>
        </template>
    </modal>
        
</template>
<script>
    import script from './ViewSelection';
    export default script;</script>

